// src/analytics.js
export const GA_ID = 'G-9KS7HTZG5L';

function hasGtag() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

export function gaEvent(name, params = {}) {
  if (hasGtag()) {
    window.gtag('event', name, params);
  }
}

// Manual page_view for SPA (initial + route changes)
export function gaPageView(path) {
  if (hasGtag()) {
    window.gtag('event', 'page_view', {
      page_location: window.location.href,
      page_path: path,
      page_title: document.title
    });
  }
}
